module.exports = __webpack_public_path__ + "static/media/cocoroboB.0707d907.svg";